// Router state passed when navigating to a document that was just created, so it opens in edit mode
// with the description editor focused. It lives in history state (not the URL) and is cleared once
// consumed, so a refresh or a shared link opens the document normally.
export const NEW_DOCUMENT_STATE = { newDocument: true } as const

export const isNewDocumentState = (state: unknown): boolean =>
  typeof state === 'object' && state !== null && (state as { newDocument?: unknown }).newDocument === true
